import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { submitSourceOfIncomeSection } from '../actions/source-of-income';
import SourceOfIncomeSection from '../components/source-of-income';
export default connect(state => ({
  sourceOfIncome: state.sourceOfIncome.fetch,
  submitSourceOfIncome: state.sourceOfIncome.submit,
  error: state.sourceOfIncome.submit.error
}), dispatch => bindActionCreators({
  submitSourceOfIncomeSection
}, dispatch))(SourceOfIncomeSection);